import { usePricePreview } from 'src/api/queries';
import { PriceConnect } from 'src/components/PriceConnect';

export function BiennialProratedPrice() {
  const proratedPrice = usePricePreview('biennial');

  return <PriceConnect price={proratedPrice.data} />;
}
